import emojiRegex from 'emoji-regex';

const testEmojiRegex =
  /^(?:(?:\p{RI}\p{RI}|\p{Emoji}(?:\p{Emoji_Modifier}|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?(?:\u{200D}\p{Emoji}(?:\p{Emoji_Modifier}|\u{FE0F}\u{20E3}?|[\u{E0020}-\u{E007E}]+\u{E007F})?)*)|[\u{1f900}-\u{1f9ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}])+$/u;

const getIsEmoji = (str: string) => {
  const regex = emojiRegex();
  const emojis = str.match(regex) || [];

  const stringToTest = str.replace(/ /g, '');

  const isEmojiOnly =
    testEmojiRegex.test(stringToTest) && Number.isNaN(Number(stringToTest));

  return emojis.length == 1 && isEmojiOnly;
};

export default getIsEmoji;
